import React from 'react';
import PropTypes from 'prop-types';

import styles from './myListsHub.scss';

// Loading skeleton for the Saved Lists Hub: `rowCount` column-matched shimmer rows (desktop, aligned to
// $hub-row-grid — Name / # Players / Recent Activity / kebab) or stacked cards (mobile, matching the
// .rowMobile grid-areas), sized to the incoming page so real rows drop in with no layout shift. Mirrors
// the List Detail PlayersLoading pattern and shares its shimmer via _skeleton.scss.
const HubLoading = ({ rowCount, isMobile, 'data-testid': dataTestId }) => {
    const rows = Array.from({ length: rowCount }, (unused, index) => index);

    if (isMobile) {
        return (
            <div className={styles.loading} data-testid={dataTestId || undefined}>
                {rows.map(index => (
                    <div
                        key={index}
                        className={styles.skeletonCard}
                        data-testid={dataTestId && `${dataTestId}.row-${index}`}
                    >
                        <span className={`${styles.shimmer} ${styles.skeletonName}`} />
                        <span className={`${styles.shimmer} ${styles.skeletonPlayers}`} />
                        <span className={`${styles.shimmer} ${styles.skeletonDot}`} />
                        <span className={`${styles.shimmer} ${styles.skeletonMenu}`} />
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className={styles.loading} data-testid={dataTestId || undefined}>
            {rows.map(index => (
                <div
                    key={index}
                    className={styles.skeletonRow}
                    data-testid={dataTestId && `${dataTestId}.row-${index}`}
                >
                    <span className={`${styles.shimmer} ${styles.skeletonName}`} />
                    <span className={`${styles.shimmer} ${styles.skeletonPlayers}`} />
                    <span className={`${styles.shimmer} ${styles.skeletonDot}`} />
                    <span className={`${styles.shimmer} ${styles.skeletonMenu}`} />
                </div>
            ))}
        </div>
    );
};

HubLoading.propTypes = {
    rowCount: PropTypes.number,
    isMobile: PropTypes.bool,
    'data-testid': PropTypes.string,
};

HubLoading.defaultProps = {
    rowCount: 0,
    isMobile: false,
    'data-testid': null,
};

export default HubLoading;
